<div fxFlex="row" fxFlex>
  <div *ngIf="showFooter" fxFlex="240px" class="sidenavigationTop hidexs hideSideNav">
    
    <div class="iwg-service-name" *ngIf="ShowEOREstimator || !EORDisabled" >Employer of Record</div>
      <div class="sidenavigationInner" style="padding-bottom:0;">
        <div *ngIf="ShowEOREstimator">
          <a href="javascript:void(0);" class="custom-sidemenu" layout
          [routerLink]="['/quoteEstimator/7b57522b-d0d6-403c-b524-1f0e2f24003c']" [queryParams]="{service: 1, global_scope: 2}">
          Estimator<span flex></span>
          <span flex></span></a>
      </div>
        <div *ngIf="ShowEORQuotes && !EORDisabled">
          <a href="javascript:void(0);" class="custom-sidemenu" layout
          [routerLink]="['/quotes']" [queryParams] = "{
              service: 1}" [ngClass]="{' active-side-nav': selectedService==1}" >
          Quotes 
          <span [ngClass]="{'sidemenuactiveiconcolor': selectedService==1}"></span>
         </a>
        </div>
        <div *ngIf="!EORDisabled">
          <a href="javascript:void(0);" class="custom-sidemenu" layout
          [routerLink]="['/assignments']" [queryParams] = "{
              service: 1}" >
          Assignments<span flex></span>
          <span flex></span></a>
      </div>
      </div>

      <div class="iwg-service-name" *ngIf="!ComplianceDisabled">Compliance</div>
      <div class="sidenavigationInner" style="padding-bottom:0;" *ngIf="!ComplianceDisabled">
        <div *ngIf="ShowComplianceQuotes">
            <a href="javascript:void(0);" class="custom-sidemenu" layout
            [routerLink]="['/quotes']" [queryParams] = "{
                service: 3}"  [ngClass]="{' active-side-nav': selectedService==3}">
            Quotes
            <span [ngClass]="{'sidemenuactiveiconcolor': selectedService==3}"></span>
          </a>
        </div>
        <div>
            <a  href="javascript:void(0);" class="custom-sidemenu" layout
            [routerLink]="['/assignments']" [queryParams] = "{
                service: 3}" >
            Evaluations<span flex></span>
            <span flex></span></a>
        </div>
    </div>

    <div class="iwg-service-name" *ngIf="!AORDisabled">Agent of Record</div>
      <div class="sidenavigationInner" style="padding-bottom:0;" *ngIf="!AORDisabled">
        <div *ngIf="ShowAORQuotes">
            <a href="javascript:void(0);" class="custom-sidemenu" layout
            [routerLink]="['/quotes']" [queryParams] = "{
                service: 2}" [ngClass]="{' active-side-nav': selectedService==2}">
            Quotes
            <span [ngClass]="{'sidemenuactiveiconcolor': selectedService==2}"></span>
          </a>
        </div>
        <div>
            <a href="javascript:void(0);" class="custom-sidemenu" layout
            [routerLink]="['/assignments']" [queryParams] = "{
                service: 2}" >
            Engagements<span flex></span>
            <span flex></span></a>
        </div>
    </div>

    

    <div class="sidenavigationInner">
      <app-buttonbar></app-buttonbar>
    </div>
    
  </div>

  <div fxFlex="calc(100% - 240px)" fxFlex.xs="100">
      <div *ngIf="!showFooter && this.userService.getRole() !='Worker'">
          <a mat-button href="#" *ngIf="selectedService === 3" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtnembed" (click)="showAssignmentDialog($event, null, 3); $event.preventDefault();" layout="row">
              Evaluate a Contractor
              <span flex></span>
              <mat-icon mat-font-set="material-icons" class="mat-iconembed">add</mat-icon>
          </a>
          <a mat-button href="#" *ngIf="selectedService !== 3" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtnembed" (click)="showAssignmentDialog($event); $event.preventDefault();" layout="row">
              Engage a Worker
              <span flex></span>
              <mat-icon mat-font-set="material-icons" class="mat-iconembed">add</mat-icon>
          </a>
          <a mat-button href="#" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtnembed" (click)="ShowQuoteDialog_embed($event); $event.preventDefault();" layout="row">
              Get a Quote
              <span flex></span>
              <mat-icon mat-font-set="material-icons" class="mat-iconembed">add</mat-icon>
          </a>
      </div>
      <div class="content">
          <div class="iwg-page-header-breadcrumb">
              <span *ngIf="showFooter">Services » </span><span>{{selectedServiceName}}</span> » <span class="iwg-page-header-small-title">Quotes</span>
          </div>
          <!--<div style="float: right;" layout="column" flex>
          <a mat-button href="#" class="mat-primary mat-raised iwg-mat-button embedbtn" (click)="showQuoteDialog($event); $event.preventDefault();" layout="row" *ngIf="ShowQuotesButton">
          Get a Quote
          <span flex></span>
          <mat-icon mat-font-set="material-icons"class="iconn">add</mat-icon>
        </a>
        <button mat-button href="#" class="mat-primary mat-raised iwg-mat-button embedbtn1" (click)="showAssignmentDialogWithManagerAndWorker($event,null,null,null,3); $event.preventDefault();" layout="row" *ngIf="showCompliance">
          Evaluate a Contractor
          <span flex></span>
          <mat-icon mat-font-set="material-icons"class="iconn">add</mat-icon>
        </button>
        </div>-->

          <div layout="column" flex>
              <div class="iwg-summary" layout="row" layout-xs="column" *ngIf="summary">
                  <ng-container *ngFor="let item of summary">
                      <div flex *ngIf="item.Name != 'Expired' || state.service == 1" [ngClass]="{'iwg-summary-item-selected': (selectedSummaryItem?.FilterName == item.FilterName
                          && selectedSummaryItem?.FilterValue == item.FilterValue)}" (click)="changeSummary(item)">
                          <div class="iwg-value">{{item.Value}}</div>
                          <div class="iwg-label">{{item.Name}}</div>
                      </div>
                  </ng-container>
              </div>
              <div>
                  <mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedTabIndex"
                                 (selectedTabChange)="onTabChanged($event);">
                      <mat-tab *ngFor="let scope of globalScopes" label="{{scope.name}}">
                          <ng-container *ngTemplateOutlet="tabContent"></ng-container>
                      </mat-tab>
                  </mat-tab-group>

                  <ng-template #tabContent>
                      <div class="vistafilter-wrapper">
                          <div class="vistafilter-section1">

                              <div class="vistafilter-innersection1" style="font-size: 15px;">Quotes Active From:</div>

                              <div class="vistafilter-innersection2">
                                  <mat-datepicker-toggle matSuffix [for]="start">
                                  </mat-datepicker-toggle>
                                  <mat-form-field appearance="none" color="accent">
                                      <input matInput [matDatepicker]="start" [(ngModel)]="state.start"
                                             [max]="state.end" (dateChange)="handleDateChange($event)">
                                      <mat-datepicker-toggle matSuffix [for]="start">
                                          <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                                      </mat-datepicker-toggle>
                                      <mat-datepicker #start></mat-datepicker>
                                  </mat-form-field>
                              </div>

                              <div class="vistafilter-innersection3">
                                  <div class="vistafilter-subsection3">To:</div>
                                  <div class="vistafilter-subsection4">
                                      <mat-datepicker-toggle matSuffix [for]="end">
                                      </mat-datepicker-toggle>
                                      <mat-form-field appearance="none" color="accent">
                                          <input matInput [matDatepicker]="end" [(ngModel)]="state.end"
                                                 [min]="state.start" (dateChange)="handleDateChange($event)">
                                          <mat-datepicker-toggle matSuffix [for]="end">
                                              <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                                          </mat-datepicker-toggle>
                                          <mat-datepicker #end></mat-datepicker>
                                      </mat-form-field>
                                  </div>
                              </div>
                          </div>

                          <div class="vistafilter-section2">
                              <div class="vistafilter-subsection1 vista-country-space" *ngIf="(state.global_scope != 3)">
                                  <app-country-select *ngIf="(state.global_scope != 3)" [(ngModel)]="state.country" [idOnly]="true"
                                                      [alltext]="'All'" [helptext]="''" [preselectedItemId]="selected" (countryChange)="handleCountryChange($event);">
                                  </app-country-select>
                              </div>

                              <div class="vistafilter-subsection1 vistafilter-subsection1-search" [ngClass]="{'vistafilter-subsection1-high':(state.global_scope == 3)}">
                                  <mat-form-field style="width: 100%;">
                                      <mat-label>Search</mat-label>
                                      <input matInput [(ngModel)]="state.q" (input)="onSearchChange($event.target.value)">
                                  </mat-form-field>
                              </div>
                              <div class="vistafilter-subsection2">
                                  <button mat-icon-button aria-hidden="false" aria-label="Download" class="inputassignicon"
                                          (click)="exportTable()" [disabled]="(loading || items?.length == 0)">
                                      <mat-icon>file_download</mat-icon>
                                  </button>
                              </div>
                          </div>
                      </div>
                  </ng-template>
              </div>


              <div class="wrapper1" #wrapper1>
                  <div class="div1" #div1></div>
              </div>
              <div class="wrapper2" #wrapper2>

                  <div class="div2" #div2>
                      <mat-progress-bar color="accent" mode="indeterminate" *ngIf="loading"></mat-progress-bar>
                      <mat-table #listTable matTableExporter matSort [dataSource]="dataSource" [matSortActive]="state.order_by"
                                 [matSortDirection]="state.order" (matSortChange)="sortData($event)" style="min-width: 100%;">


                          <ng-container matColumnDef="QuoteID">
                              <mat-header-cell *matHeaderCellDef mat-sort-header="QuoteIDLabel" disableClear>Reference ID</mat-header-cell>
                              <mat-cell *matCellDef="let quotes">
                                  <a matTooltip="{{this.utils.htmlDecode(quotes.Title)}}" matTooltipPosition="below" [routerLink]="['/quotes', quotes.ID]"
                                     [queryParams]="{
                                  quoteId: quotes.ID,
                                service: state.service,
                                page: state.page,
                                limit: state.limit,
                                order_by: state.order_by,
                                order: state.order,
                                start: state.start,
                                end: state.end,
                                q: state.q,
                                country: (state.country && state.country.Abbreviation ? state.country.Abbreviation : state.country),
                                global_scope: state.global_scope,
                                isUSA: quotes.Country === 'USA' ? true : false
                              }">{{quotes.QuoteID}}</a>
                              </mat-cell>
                          </ng-container>


                          <ng-container matColumnDef="Title">
                              <mat-header-cell *matHeaderCellDef mat-sort-header="TitleLabel" disableClear>Quote</mat-header-cell>
                              <mat-cell *matCellDef="let quotes">
                                  <a matTooltip="{{this.utils.htmlDecode(quotes.Title)}}" matTooltipPosition="below" [routerLink]="['/quotes', quotes.ID]"
                                     [queryParams]="{
                                  quoteId: quotes.ID,
                                service: state.service,
                                page: state.page,
                                limit: state.limit,
                                order_by: state.order_by,
                                order: state.order,
                                start: state.start,
                                end: state.end,
                                q: state.q,
                                country: (state.country && state.country.Abbreviation ? state.country.Abbreviation : state.country),
                                global_scope: state.global_scope
                              }"> {{this.utils.htmlDecode(quotes.Title)}}</a>
                              </mat-cell>
                          </ng-container>


                          <ng-container matColumnDef="EndClient">
                              <mat-header-cell *matHeaderCellDef mat-sort-header="EndClientLabel" disableClear class="tabledhead hidexs">
                                  End Client
                              </mat-header-cell>
                              <mat-cell *matCellDef="let quotes" class="tabledbody hidexs"> {{quotes.EndClientName}} </mat-cell>
                          </ng-container>


                          <ng-container matColumnDef="JobTitle">
                              <mat-header-cell *matHeaderCellDef mat-sort-header="JobTitleLabel" disableClear class="hidexs">
                                  Job Title
                              </mat-header-cell>
                              <mat-cell *matCellDef="let quotes" class="hidexs"> {{this.utils.htmlDecode(quotes.JobTitle)}} </mat-cell>
                          </ng-container>


                          <ng-container matColumnDef="Location">
                              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs">Country</mat-header-cell>
                              <mat-cell *matCellDef="let quotes" class="hidexs"> {{quotes.Country}} </mat-cell>
                          </ng-container>


                          <ng-container matColumnDef="StatusName">
                              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Status</mat-header-cell>
                              <mat-cell *matCellDef="let quotes"> {{quotes.Status}} </mat-cell>
                          </ng-container>


                          <ng-container matColumnDef="WorkerCount">
                              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs">Workers</mat-header-cell>
                              <mat-cell *matCellDef="let quotes" class="hidexs"> {{quotes.NumberOfWorkers}} </mat-cell>
                          </ng-container>



                          <ng-container matColumnDef="DateRequested">
                              <mat-header-cell *matHeaderCellDef mat-sort-header="DateRequestedLabel" disableClear class="hidexs">
                                  Submitted
                              </mat-header-cell>
                              <mat-cell *matCellDef="let quotes" class="hidexs"> {{quotes.DateRequested | date}} </mat-cell>
                          </ng-container>


                          <ng-container matColumnDef="Expiration">
                              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs">
                                  Expiration
                              </mat-header-cell>
                              <mat-cell *matCellDef="let quotes" class="hidexs"> {{quotes.QuoteExpirationDate | date}} </mat-cell>
                          </ng-container>


                          <ng-container matColumnDef="Price">
                              <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Price</mat-header-cell>
                              <mat-cell *matCellDef="let quotes">
                                  <ng-container *ngIf="quotes.Country !== 'USA' && state.service == 1">
                                      <span *ngIf="(quotes.StatusID==6 || quotes.StatusID==7)">
                                          {{quotes.EstimatedMonthlyInvoiceUSD | currency:'$':'symbol-narrow':'1.2-2'}}
                                          {{quotes.EstimatedMonthlyInvoiceUSD || quotes.EstimatedMonthlyInvoiceUSD == 0 ? "(" + quotes.EntityCurrencyCode + ")" : ''}}
                                      </span>
                                  </ng-container>
                                  <ng-container *ngIf="quotes.Country === 'USA' && state.service == 1">
                                      <span *ngIf="(quotes.StatusID==6 || quotes.StatusID==7)">
                                          {{quotes.ClientMarkup | percentage : '1.2-2'}}
                                      </span>
                                  </ng-container>
                                  <ng-container *ngIf="state.service != 1">
                                      <span *ngIf="(quotes.StatusID==6 || quotes.StatusID==7)">
                                          {{quotes.EstimatedMonthlyInvoiceUSD | currency:'$':'symbol-narrow':'1.2-2'}}
                                          {{quotes.EstimatedMonthlyInvoiceUSD || quotes.EstimatedMonthlyInvoiceUSD == 0 ? "(" + quotes.EntityCurrencyCode + ")" : ''}}
                                      </span>
                                  </ng-container>
                              </mat-cell>
                          </ng-container>


                          <ng-container matColumnDef="ClientMarkup">
                              <mat-header-cell *matHeaderCellDef mat-sort-header="ClientMarkupLabel" disableClear class="hidexs">
                                  Markup (%)
                              </mat-header-cell>
                              <mat-cell *matCellDef="let quotes" class="hidexs"> {{quotes.ClientMarkup | percentage : '1.2-2'}} </mat-cell>
                          </ng-container>


                          <ng-container matColumnDef="SalesTax">
                              <mat-header-cell *matHeaderCellDef mat-sort-header="SalesTaxLabel" disableClear class="hidexs">
                                  Sales Tax (%)
                              </mat-header-cell>
                              <mat-cell *matCellDef="let quotes" class="hidexs"> {{quotes.SalesTax | percentage : '1.2-2'}} </mat-cell>
                          </ng-container>


                          <ng-container matColumnDef="OprMenu">
                              <mat-header-cell *matHeaderCellDef class="hidexs"></mat-header-cell>
                              <mat-cell *matCellDef="let quotes" class="hidexs">
                                  <button mat-icon-button [matMenuTriggerFor]="elementMenu" aria-label="Menu">
                                      <mat-icon>more_vert</mat-icon>
                                  </button>

                                  <mat-menu #elementMenu="matMenu" class="submenu">
                                      <button mat-menu-item [routerLink]="['/quotes', quotes.ID]" [queryParams]="{
                                  quoteId: quotes.ID,
                                  service: state.service,
                                  page: state.page,
                                  limit: state.limit,
                                  order_by: state.order_by,
                                  order: state.order,
                                  start: state.start,
                                  end: state.end,
                                  q: state.q,
                                  country: (state.country && state.country.Abbreviation ? state.country.Abbreviation : state.country),
                                  global_scope: state.global_scope
                                }">
                                          Show Details
                                      </button>

                                      <button mat-menu-item *ngIf="ShowEngageButton && quotes.StatusID == 6"
                                              (click)="showAssignmentDialog($event,quotes.PriceQuoteGUID)">
                                          Add {{labelSingular}}
                                      </button>
                                      <button mat-menu-item *ngIf="quotes.StatusID == 1"
                                              (click)="showTransferAssignmentDialog($event,quotes.ID)">
                                          Edit
                                      </button>
                                  </mat-menu>

                              </mat-cell>
                          </ng-container>

                          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                      </mat-table>

                  </div>
              </div>

              <mat-paginator [length]="totalRecords" [pageSize]="state.limit" class="myvista-paginator"
                             (page)="pageEvent = $event; naviatePageTo($event)" [pageSizeOptions]="[25, 100, 500, 1000, 10000]"
                             showFirstLastButtons>
              </mat-paginator>

          </div>

      </div>
      <div *ngIf="showFooter" class="innerpage-footer">
          <app-iwg-footer [blurBg]="true"></app-iwg-footer>
      </div>
  </div>
</div>